import { Link } from "react-router-dom";
import { Facebook, Instagram, MessageCircle, MapPin, Phone, Mail } from "lucide-react";
import { BRAND, PRODUCTS, WHATSAPP_LINK } from "../lib/brand";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0B2545] text-white pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
      <div>
        <img
          src={BRAND.logoUrl}
          alt="Gravityinc"
          className="h-14 w-auto object-contain mb-5"
          style={{
            filter: "saturate(0) brightness(3)",
            mixBlendMode: "screen",
          }}
        />
        <p className="text-white/70 text-sm leading-relaxed mb-4">
          Retail automation &amp; POS solutions, in-house built and trusted by 3,000+ businesses.
        </p>
        <div className="space-y-2 text-sm text-white/70">
          <div className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-[#00B4D8]" /> {BRAND.address}</div>
          <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#00B4D8]" /> {BRAND.phone1} · {BRAND.phone2}</div>
          <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#00B4D8]" /> GST: {BRAND.gst}</div>
        </div>
      </div>

      <div>
        <h5 className="font-display font-semibold text-white mb-4">Products</h5>
        <ul className="space-y-2 text-sm text-white/70">
          {PRODUCTS.map((p) => (
            <li key={p.slug}>
              <Link
                to={`/digipos/${p.slug}`}
                data-testid={`footer-product-${p.slug}`}
                className="hover:text-white hover:translate-x-1 inline-block transition"
              >
                {p.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h5 className="font-display font-semibold text-white mb-4">Company</h5>
        <ul className="space-y-2 text-sm text-white/70">
          <li><Link to="/about" className="hover:text-white transition">About Us</Link></li>
          <li><Link to="/hardware" className="hover:text-white transition">Hardware</Link></li>
          <li><Link to="/contact" className="hover:text-white transition">Contact Us</Link></li>
          <li><Link to="/digipos" className="hover:text-white transition">DigiPOS Suite</Link></li>
        </ul>
      </div>

      <div>
        <h5 className="font-display font-semibold text-white mb-4">Connect</h5>
        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp"
          className="gi-btn-whatsapp mb-4"
        >
          <MessageCircle className="h-4 w-4" /> Chat on WhatsApp
        </a>
        <div className="flex items-center gap-3 mt-2">
          <a href="#" aria-label="Facebook" className="h-10 w-10 grid place-items-center rounded-full bg-white/8 border border-white/10 text-white hover:bg-[#1565C0] hover:border-[#1565C0] transition">
            <Facebook className="h-4 w-4" />
          </a>
          <a href="#" aria-label="Instagram" className="h-10 w-10 grid place-items-center rounded-full bg-white/8 border border-white/10 text-white hover:bg-[#00B4D8] hover:border-[#00B4D8] transition">
            <Instagram className="h-4 w-4" />
          </a>
        </div>
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
      <p className="text-white/40 text-xs">© 2026 Gravityinc Business Solutions. GST: {BRAND.gst}</p>
      <p className="text-white/40 text-xs">Made in Kochi, Kerala · India</p>
    </div>
  </footer>
);

export default Footer;
